import type { ReactNode } from "react";
import { AlertCircle, CheckCircle2, Info } from "lucide-react";
import { cn } from "@/lib/cn";

type Tone = "info" | "success" | "error";

const TONE: Record<Tone, { wrap: string; Icon: typeof Info }> = {
  info: { wrap: "border-zinc-200 bg-zinc-50 text-zinc-700", Icon: Info },
  success: { wrap: "border-emerald-200 bg-emerald-50 text-emerald-800", Icon: CheckCircle2 },
  error: { wrap: "border-red-200 bg-red-50 text-red-800", Icon: AlertCircle },
};

export function Alert({
  tone = "info",
  title,
  children,
}: {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
}): JSX.Element {
  const { wrap, Icon } = TONE[tone];
  return (
    <div className={cn("flex items-start gap-3 rounded-md border px-4 py-3 text-sm", wrap)}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="min-w-0 flex-1">
        {title ? <p className="font-medium">{title}</p> : null}
        {children ? (
          <div className={cn(title ? "mt-1" : "", "text-sm/relaxed")}>{children}</div>
        ) : null}
      </div>
    </div>
  );
}
